import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthService } from 'src/app/pages/login/service/auth.service';
import { OrganizationChartService } from '../../../pages/admin/entities-manager/service/organization-chart.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslatePipe],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  @Input() isHidden = false;
  @Output() isHiddenChange = new EventEmitter<boolean>();

  menuItems: any[] = [
    {
      title: 'Administrator',
      icon: 'pi pi-cog',
      isOpen: true,
      children: [
        { title: 'File Management', routerLink: '/file-upload', icon: 'pi pi-upload' },
        {
          title: 'Entities Manager',
          icon: 'pi pi-building',
          routerLink: '/entities-manager/all-entities',
        },
        // Aquí movemos directamente los hijos de "Categories", y los colocamos en orden
        {
          title: 'KPIs Management',
          routerLink: '/kpi-management',
          icon: 'pi pi-users',
        },
        {
          title: 'Thresholds Settings',
          routerLink: '/categories',
          icon: 'pi pi-sliders-h',
        },
        {
          title: 'Users Management',
          routerLink: '/user-management',
          icon: 'pi pi-users',
        },
      ],
    },
  ];

  constructor(private authService: AuthService) {}

  toggleSidebar() {
    this.isHidden = !this.isHidden;
    this.isHiddenChange.emit(this.isHidden);
  }

  toggleMenu(item: any) {
    item.isOpen = !item.isOpen;
  }

  getUserRole(): string | null {
    return this.authService.getUserRole();
  }

  logout() {
    this.authService.logout();
  }
}
